import { useLocation } from "wouter";
import { Home, FolderOpen, Clock, Receipt, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useState } from "react";

const NAV_ITEMS = [
  { href: "/", icon: Home, label: "Home" },
  { href: "/projects", icon: FolderOpen, label: "Projects" },
  { href: "/time-tracking", icon: Clock, label: "Time" },
  { href: "/receipts", icon: Receipt, label: "Receipts" },
];

export default function MobileBottomNav() {
  const [location, navigate] = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border safe-area-pb">
      <div className="flex items-center justify-around h-16 px-2">
        {NAV_ITEMS.map((item) => {
          const isActive = location === item.href || (item.href !== "/" && location.startsWith(item.href));
          return (
            <button
              key={item.href}
              onClick={() => navigate(item.href)}
              className={`flex flex-col items-center justify-center gap-0.5 w-16 h-14 rounded-lg transition-colors touch-manipulation ${
                isActive
                  ? "text-primary bg-primary/10"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <item.icon className="h-5 w-5" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
        <button
          onClick={() => setOpen(true)}
          className="flex flex-col items-center justify-center gap-0.5 w-16 h-14 rounded-lg transition-colors touch-manipulation text-muted-foreground hover:text-foreground"
        >
          <Menu className="h-5 w-5" />
          <span className="text-[10px] font-medium">More</span>
        </button>
      </div>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="h-[70vh] rounded-t-2xl">
          <div className="grid grid-cols-3 gap-3 p-4 pt-6">
            {[
              { href: "/schedule", label: "Schedule", icon: "📅" },
              { href: "/leads", label: "Leads", icon: "👥" },
              { href: "/invoices", label: "Invoices", icon: "📄" },
              { href: "/estimates", label: "Estimates", icon: "📝" },
              { href: "/subcontractors", label: "Subs", icon: "🏗️" },
              { href: "/purchase-orders", label: "POs", icon: "📦" },
              { href: "/daily-reports", label: "Daily Reports", icon: "📋" },
              { href: "/warranties", label: "Warranties", icon: "🛡️" },
              { href: "/lien-waivers", label: "Lien Waivers", icon: "📜" },
              { href: "/punch-list", label: "Punch List", icon: "✅" },
              { href: "/vendors", label: "Vendors", icon: "🏪" },
              { href: "/search", label: "Search", icon: "🔍" },
            ].map((item) => (
              <button
                key={item.href}
                onClick={() => { navigate(item.href); setOpen(false); }}
                className="flex flex-col items-center justify-center gap-2 p-4 rounded-xl border border-border hover:bg-accent transition-colors touch-manipulation"
              >
                <span className="text-2xl">{item.icon}</span>
                <span className="text-xs font-medium text-center">{item.label}</span>
              </button>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </nav>
  );
}
